import { useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export const inputCls =
  "w-full bg-black border border-white/15 px-3 py-2 text-sm text-white focus:border-[#ffde00] focus:outline-none rounded-none";

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="font-mono2 text-[10px] text-[#a1a1aa] tracking-[0.25em] uppercase block mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export const TextInput = (props) => <input className={inputCls} {...props} />;
export const AreaInput = (props) => <textarea className={`${inputCls} resize-none font-zh`} {...props} />;
export const SelectInput = ({ options, ...props }) => (
  <select className={`${inputCls} font-zh`} {...props}>
    {options.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
);

export const PanelShell = ({ title, children, onAdd }) => (
  <div>
    <div className="flex items-center justify-between mb-6">
      <h2 className="font-display text-2xl uppercase text-white">{title}</h2>
      {onAdd && (
        <button onClick={onAdd} className="btn-yellow !py-2 !px-4" data-testid={`admin-add-${title}`}>
          <Plus size={14} /> 新增
        </button>
      )}
    </div>
    {children}
  </div>
);

export const EditorShell = ({ title, onClose, onSubmit, children, busy }) => (
  <div className="fixed inset-0 z-[150] bg-black/80 flex items-start md:items-center justify-center p-4 overflow-y-auto">
    <div className="bg-[#0a0a0a] border border-white/15 w-full max-w-2xl p-6 md:p-8 my-8">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-display text-xl uppercase text-[#ffde00]">{title}</h3>
        <button onClick={onClose} className="text-[#a1a1aa] hover:text-white bg-transparent border-0 cursor-pointer">
          <X size={20} />
        </button>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        className="space-y-4"
      >
        {children}
        <div className="flex gap-3 pt-2">
          <button type="submit" disabled={busy} className="btn-yellow !py-2.5 disabled:opacity-50" data-testid="admin-editor-save">
            {busy ? "保存中…" : "保存"}
          </button>
          <button type="button" onClick={onClose} className="btn-ghost !py-2.5">
            取消
          </button>
        </div>
      </form>
    </div>
  </div>
);

export const RowActions = ({ onEdit, onDelete }) => (
  <div className="flex gap-2 justify-end">
    {onEdit && (
      <button onClick={onEdit} className="text-[#a1a1aa] hover:text-[#ffde00] bg-transparent border-0 cursor-pointer p-1" data-testid="admin-row-edit" aria-label="编辑">
        <Pencil size={15} />
      </button>
    )}
    <button onClick={onDelete} className="text-[#a1a1aa] hover:text-red-400 bg-transparent border-0 cursor-pointer p-1" data-testid="admin-row-delete" aria-label="删除">
      <Trash2 size={15} />
    </button>
  </div>
);

export const useCrud = (resource) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () =>
    api
      .get(`/${resource}`)
      .then((r) => setItems(r.data))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  return { items, loading, load };
};

export const del = async (resource, id, label) => {
  if (!window.confirm(`确定删除「${label}」？`)) return false;
  try {
    await api.delete(`/${resource}/${id}`);
    toast.success("已删除");
    return true;
  } catch (e) {
    toast.error(formatApiError(e));
    return false;
  }
};
